export default function registerSW() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/pwa-service-worker.js`);
  }
}
